<footer class="site-footer">
  <div class="site-footer__inner">
    <!-- Marca + tagline -->
    <div class="site-footer__brand">
      <a routerLink="/" class="site-footer__logo" aria-label="Inicio">
        <img
          [src]="
            theme.isDark()
              ? 'assets/img/logo/logo-todosector-base-white.png'
              : 'assets/img/logo/logo-todosector-base.png'
          "
          alt="Logotipo {{ app.business.name || '' }}" />
      </a>
      <p class="site-footer__tagline">
        Gestión modular para pymes operativas. Cumplimiento conectado, sin la
        complejidad de las grandes suites. Palma de Mallorca.
      </p>
      <p class="site-footer__place">Hecho en Palma de Mallorca</p>
    </div>

    <!-- Columnas -->
    <nav class="site-footer__col">
      <h3>Producto</h3>
      <a routerLink="/modulos">Módulos</a>
      <a routerLink="/precios">Precios</a>
      <a routerLink="/soluciones">Soluciones</a>
      <a routerLink="/prueba-sin-compromiso">Prueba sin compromiso</a>
    </nav>

    <nav class="site-footer__col">
      <h3>Recursos</h3>
      <a routerLink="/ayuda">Centro de ayuda</a>
      <a routerLink="/verifactu">Verifactu</a>
      <a routerLink="/a-medida">Desarrollos a medida</a>
      <a routerLink="/contacto">Contacto</a>
    </nav>

    <nav class="site-footer__col">
      <h3>Legal</h3>
      <a routerLink="/aviso-legal">Aviso legal</a>
      <a routerLink="/privacidad">Política de privacidad</a>
      <a routerLink="/cookies">Política de cookies</a>
      <a href="#" class="pdcc-open-modal">Configurar cookies</a>
    </nav>
  </div>

  <div class="site-footer__bottom">
    <span>&reg; {{ currentYear }} {{ app.business.name || '' }}</span>
    <span class="site-footer__vat">Precios sin IVA incluido.</span>
  </div>
</footer>

<p-scrollTop />
